/**
 * cs-wishlist.js — LocalStorage-based wishlist for Cadouri Superbe
 * No backend required. Persists per browser session.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cs_wishlist_ids';

  /* --- Storage helpers --- */
  function getIds() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveIds(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function isWishlisted(id) {
    return getIds().indexOf(String(id)) !== -1;
  }

  function toggle(id) {
    var ids = getIds();
    var strId = String(id);
    var idx = ids.indexOf(strId);
    if (idx === -1) {
      ids.push(strId);
    } else {
      ids.splice(idx, 1);
    }
    saveIds(ids);
    return idx === -1; /* true = added */
  }

  /* --- UI helpers --- */
  function updateBtn(btn, wishlisted) {
    btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    btn.setAttribute('aria-label', wishlisted ? 'Elimină din wishlist' : 'Adaugă la wishlist');
    btn.classList.toggle('cs-wishlist-btn--active', wishlisted);
    /* Update the SVG fill */
    var icon = btn.querySelector('.cs-wishlist-btn__icon');
    if (icon) {
      icon.setAttribute('fill', wishlisted ? 'currentColor' : 'none');
    }
  }

  function initButtons() {
    document.querySelectorAll('[data-wishlist-id]').forEach(function (btn) {
      var id = btn.dataset.wishlistId;
      updateBtn(btn, isWishlisted(id));

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); /* Don't trigger card click */
        var added = toggle(id);
        updateBtn(btn, added);

        /* Dispatch custom event for analytics/integrations */
        document.dispatchEvent(new CustomEvent('cs:wishlist:change', {
          bubbles: true,
          detail: { id: id, added: added }
        }));
      });
    });
  }

  /* Init on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }

  /* Re-init after Shopify section renders (e.g., infinite scroll, quickview) */
  document.addEventListener('shopify:section:load', initButtons);
})();
